import {
  SET_SELECTED_INVENTORY_ITEMS,
  CLEAR_SELECTED_INVENTORY_ITEMS,
  TOGGLE_INVENTORY_ITEM
} from "./types";

export const setSelectedInventoryItems = (items) => ({
  type: SET_SELECTED_INVENTORY_ITEMS,
  payload: items
});

export const clearSelectedInventoryItems = () => ({
  type: CLEAR_SELECTED_INVENTORY_ITEMS
});

export const toggleInventoryItem = (item) => ({
  type: TOGGLE_INVENTORY_ITEM,
  payload: item
});
